import { createReducer } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import * as storageActions from 'store/amwell/storage/actions';
import * as visitActions from 'store/amwell/visit/actions';
import { RESET_AMWELL_ACTIVITY } from '../activeConsumer/actions';
import { VisitContext } from './types';
import * as actions from './actions';

export type VisitContextState = Readonly<{
  data: Nullable<VisitContext>;
  disclaimersAcknowledged: boolean;
  loading: {
    data: boolean;
    action: boolean;
  };
  errors: {
    data: Nullable<Error>;
    action: Nullable<Error>;
  };
}>;

export const visitContextInitialState: VisitContextState = {
  data: null,
  disclaimersAcknowledged: false,
  loading: { data: false, action: false },
  errors: { data: null, action: null }
};

export const visitContextReducer = createReducer(visitContextInitialState, {
  [actions.GET_VISIT_CONTEXT]: state => {
    state.loading.data = true;
    state.errors.data = null;
  },
  [actions.GET_VISIT_CONTEXT_FAIL]: (state, action) => {
    state.errors.data = action.error;
    state.loading.data = false;
  },
  [actions.GET_VISIT_CONTEXT_SUCCESS]: (state, action) => {
    state.data = action.payload.visitContext;
    state.disclaimersAcknowledged = action.payload.disclaimersAcknowledged;
    state.loading.data = false;
  },
  [visitActions.CREATE_VISIT_FROM_SPEED_PASS_SUCCESS]: (state, action) => {
    if (action.payload.visitContext) {
      // to Protect mobile
      state.data = action.payload.visitContext;
      state.disclaimersAcknowledged = action.payload.disclaimersAcknowledged;
      state.loading.data = false;
    }
  },
  [actions.CREATE_VISIT_CONTEXT_WITH_APPOINTMENT]: state => {
    state.loading.data = true;
    state.errors.data = null;
  },
  [actions.CREATE_VISIT_CONTEXT_WITH_APPOINTMENT_FAIL]: (state, action) => {
    state.errors.data = action.error;
    state.loading.data = false;
  },
  [actions.CREATE_VISIT_CONTEXT_WITH_APPOINTMENT_SUCCESS]: (state, action) => {
    state.data = action.payload.visitContext;
    state.disclaimersAcknowledged = action.payload.disclaimersAcknowledged;
    state.loading.data = false;
  },
  [actions.UPDATE_VISIT_CONTEXT]: state => {
    state.errors.action = null;
    state.loading.action = true;
  },
  [actions.UPDATE_VISIT_CONTEXT_FAIL]: (state, action) => {
    state.errors.action = action.error;
    state.loading.action = false;
  },
  [actions.UPDATE_VISIT_CONTEXT_SUCCESS]: (state, action) => {
    state.data = action.payload.visitContext;
    state.disclaimersAcknowledged = action.payload.disclaimersAcknowledged;
    state.loading.action = false;
  },
  [visitActions.TRANSFER_VISIT_SUCCESS]: (state, action) => {
    state.data = action.payload.visitContext;
    state.disclaimersAcknowledged = action.payload.disclaimersAcknowledged;
  },
  // Web Amwell Session Restore
  [storageActions.GET_STORAGE_SUCCESS]: (state, action) => {
    state.data = action.payload.visitContext;
    state.disclaimersAcknowledged = action.payload.disclaimersAcknowledged;
  },
  [RESET_AMWELL_ACTIVITY]: () => visitContextInitialState
});
